<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M6.8 8.7V2.1q0-.5.3-.8T8 1t.8.3.3.8v6.6h1.1V2.1q0-.5.3-.8t.8-.3.8.3.3.8v6.6q0 1.6-1 2.7T9 12.9v9q0 .5-.3.8l-.8.3-.8-.3-.3-.8v-9q-1.4-.3-2.4-1.5t-.9-2.7V2.1q0-.5.3-.8t.8-.3.8.3.3.8v6.6zm11 5.5h-2.2l-.8-.3-.3-.8V6.5a6 6 0 0 1 1.4-3.7Q17.4 1 19 1q.5 0 .8.4.3.3.3.9v19.6q0 .5-.3.8l-.8.3-.8-.3-.3-.8z"
    />
  </svg>
</template>
